import React from 'react'

import {Text} from '@vio/atlas/Text'
import {FormattedMessageWrapper} from '@vio/core/src/localization/components/FormattedMessage'

export const YourChoiceLabel = () => {
  return (
    <Text
      data-id="YourChoiceLabel"
      variant="bodyXS"
      colorPath="content.success.secondary"
    >
      <FormattedMessageWrapper
        id="yourSelection"
        defaultMessage="Your selection"
      />
    </Text>
  )
}
